const Smile = require('./smile.png')
const Product = require('./product.jpg')
const Bubbles = require('./bubbles.jpg')
const Chair = require('./chair.jpg')
// Art direction from the brand book's People page, not Wally's own: licence or reshoot before release.
const SmileBite = require('./smile-bite.jpg')
// Wally's own, from carebywally.com's Who We Are page: a laugh, eyes closed, gold earrings.
const Laugh = require('./laugh.jpg')
const AppStoreButton = require('./app-store-button.svg')
const PlayStoreButton = require('./play-store-button.svg')

/**
 * The brand's three photographs. The smile is the hero and the desktop pane; the product shot
 * on coral is for empty states and the membership; the bubbles sit behind the score.
 */
export default {
	Smile,
	BrandPhoto: Smile,
	Product,
	Bubbles,
	/** A cleaning in the chair: the tools-and-tech photo the brand book leads with. */
	Chair,
	SmileBite,
	/** The front door's photograph: the laugh that says what the visit is for. */
	Laugh,
	AppStoreButton,
	PlayStoreButton,
}
